/* global axios */
import ApiClient from '../ApiClient';

class AsteriskApiClient extends ApiClient {
  constructor(resource) {
    super(`asterisk/${resource}`, { accountScoped: true });
  }
}

export default AsteriskApiClient;
